if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super()

        this.form = this.querySelector("form")
        this.form.querySelector("[name=id]").disabled = false
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this))
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer")
        this.submitButton = this.querySelector('[type="submit"]')

        if (document.querySelector("cart-drawer")) this.submitButton.setAttribute("aria-haspopup", "dialog")

        this.hideErrors = this.dataset.hideErrors === "true"
        document.addEventListener("activeVariantUpdated", this.handleActiveProductVariant.bind(this))
      }
      handleActiveProductVariant(event) {
        const { activeVariant, activeProduct } = event.detail
        this.form.querySelector("[name=id]").value = activeVariant.id
        this.form.querySelector("[name=product-id]").value = activeProduct.id
      }

      connectedCallback() {
        subscribe(PUB_SUB_EVENTS.cartError, async (event) => {
          this.handleErrorMessage(event.message);
     
          this.submitButton.classList.remove("loading")
          this.submitButton.querySelector("span").classList.remove("hidden")
          this.submitButton.removeAttribute("aria-disabled")
          this.querySelector(".gz-loader").classList.add("hidden")
        });
      }

      async onSubmitHandler(evt) {
        evt.preventDefault()
        if (this.submitButton.getAttribute("aria-disabled") === "true") return

        this.handleErrorMessage()
        this.submitButton.setAttribute("aria-disabled", true)
        this.submitButton.classList.add("loading")
        this.querySelector(".gz-loader").classList.remove("hidden")

        const config = fetchConfig("javascript")
        config.headers["X-Requested-With"] = "XMLHttpRequest"
        delete config.headers["Content-Type"]

        const formData = new FormData(this.form);

        let properties = {};
        const upgradedDDEle = document.querySelector('input[name="__gzdd"]'); 
        const upgradedDDStorage = document.querySelector('input[name="__gzddst"]');

        if (upgradedDDEle && upgradedDDEle.value) {
          formData.append('properties[__gzdd]', upgradedDDEle.value);
          properties["__gzdd"] = upgradedDDEle.value;
        }

        if (upgradedDDStorage && upgradedDDStorage.value) {
          formData.append('properties[__gzst]', upgradedDDStorage.value);
          properties["__gzst"] = upgradedDDStorage.value;
        }

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          )
          formData.append("sections_url", window.location.pathname)
          this.cart.setActiveElement(document.activeElement)
        }
        config.body = formData

        const productVariantId = parseInt(formData.get("id"));
     
        // Protection Plan Exists - publish 'productAdded' gz-protection-plan to handle adding protection plan
        const protectionPlan = document.querySelector("gz-protection-plan");
        if (protectionPlan) {
          publish(PUB_SUB_EVENTS.productAdded, {
            itemAdded: { id: productVariantId, properties: properties || null },
          });

        // No Protection Plan detected on PDP, add product without protection plan
        } else {
          let addToCartSuccessful = false;
          const productToAdd = { id: productVariantId, properties: properties };

          try {
            // Attempt to add product to cart
            await window.GzTheme.addProductToCart(productToAdd, null, false);
            addToCartSuccessful = true;
          } catch (error) {
            // Show error on PDP
            this.handleErrorMessage(error);
            this.submitButton.classList.remove("loading");
            this.submitButton.querySelector("span").classList.remove("hidden");
            this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".gz-loader").classList.add("hidden");

            // Log the error to DataDog
            window.GzTheme.sendLogsToDataDog({
              error,
              message: 'Error adding product to cart from productAdded event',
              payload: {
                itemAdded: productToAdd,
                protectionPlanId: null,
                planSelected: false
              }
            });

            throw error;
          } finally {
            if (addToCartSuccessful) {
              window.location = window.routes.cart_url;
            }
          }
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return

        const soldOutMessage = this.submitButton.querySelector(".sold-out-message")
        this.submitButton.setAttribute("aria-disabled", true)
        this.submitButton.querySelector("span").classList.add("hidden")
        soldOutMessage?.classList.remove("hidden")
        this.error = true

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper")
        if (!this.errorMessageWrapper) return
        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message")

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage)

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage
        }
      }
    },
  )
}